import React, { useImperativeHandle, useRef } from "react";
import { Grid } from "@mui/material";
import { MASK_TYPE, TextField } from "@curves/ui-base";
import { refIsRequiredError, getErrorModuleStatus } from "@util/utils";

/**
 * 非會員欄位組件
 * 用於輸入非會員的姓名和手機號碼
 */
const NonMemberField = React.forwardRef((props, ref) => {
	const { readOnly, errorModule = {} } = props;
	const nameRef = useRef(null);
	const telRef = useRef(null);

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => {
				return {
					receiverName: nameRef.current?.getResult(),
					receiverPhone: telRef.current?.getResult(),
				};
			},
			isError: () => refIsRequiredError(nameRef, telRef),
		}),
		// eslint-disable-next-line
		[],
	);

	return (
		<React.Fragment>
			<Grid xs={3} item>
				<TextField label="姓名" ref={nameRef} disabled={readOnly} fullWidth required {...getErrorModuleStatus(errorModule, "receiverName")} />
			</Grid>
			<Grid xs={3} item>
				<TextField label="手機號碼" ref={telRef} maskType={MASK_TYPE.MOB} disabled={readOnly} fullWidth required {...getErrorModuleStatus(errorModule, "receiverPhone")} />
			</Grid>
		</React.Fragment>
	);
});

NonMemberField.displayName = "NonMemberField";

export default NonMemberField;

